import React from 'react'

type Props = {
  className?: string
  fillColor?: string
  size?: number
}

// Stroke chevron (the Feedback Inbox Sketch prototype's dropdown caret) — the
// existing `ChevronDown` is a filled 8x5 triangle.
const ChevronDownOutline = ({
  className,
  fillColor = 'currentColor',
  size = 16,
}: Props) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={fillColor}
    strokeWidth="2.4"
    strokeLinecap="round"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="m6 9 6 6 6-6" />
  </svg>
)

export default ChevronDownOutline
